import { Trans, useLingui } from '@lingui/react/macro';
import type { UseQueryResult } from '@tanstack/react-query';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';

import type { Visit } from '../../../@types/visits';
import { VideaTypography } from '../../../common-components/elements/VideaTypography/VideaTypography';
import type { RecentVisitsResponse } from '../../../react-query/useGetRecentVisits';

interface VisitSelectorProps {
  recentVisitsQuery: UseQueryResult<RecentVisitsResponse>;
  selectedVisit?: number;
  onVisitChange: (visitId: string) => void;
}

export const VisitSelector = ({
  recentVisitsQuery,
  selectedVisit,
  onVisitChange,
}: VisitSelectorProps) => {
  const { t } = useLingui();
  const visits = recentVisitsQuery.data?.visits || [];

  return (
    <div className="vai-flex vai-flex-col vai-gap-3">
      <VideaTypography variant="labelSmall">
        <Trans>Step 1: Select a Recent Visit</Trans>
      </VideaTypography>
      {recentVisitsQuery.isLoading ? (
        <div className="vai-p-4 vai-text-center vai-text-gray-500">
          <Trans>Loading recent visits...</Trans>
        </div>
      ) : recentVisitsQuery.isError ? (
        <div className="vai-p-4 vai-text-center vai-text-red-600">
          <Trans>Error loading visits. Please try again.</Trans>
        </div>
      ) : (
        <Select value={selectedVisit?.toString()} onValueChange={onVisitChange}>
          <SelectTrigger className="vai-w-full">
            <SelectValue placeholder={t`Choose a visit...`} />
          </SelectTrigger>
          <SelectContent>
            {visits.map((visit: Visit) => (
              <SelectItem key={visit.id} value={visit.id!.toString()}>
                {new Date(visit.visitDate!).toLocaleDateString()} (
                {visit.imageTypeCounts.reduce(
                  (acc, curr) =>
                    curr.type === 'BITEWING' || curr.type === 'PERIAPICAL'
                      ? acc + (Number(curr.count) ?? 0)
                      : acc,
                  0,
                )}{' '}
                images)
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
};
